import { TRELLO } from '../../../constants/import-type';
import {
	DEFAULT_CONFIG,
	type StepComponent,
	IMPORT_IN_PROGRESS_STEP,
	PROJECT_CREATE_STEP,
	SELECT_THIRD_PARTY_ENTITY_STEP,
	StatisticsType,
	USER_MAPPING_STEP,
	SELECT_SOURCE_STEP,
} from '../../../constants/steps';
import commonMessages from '../messages';
import messages from './messages';

export const getTrelloSteps = (hiddenUsers?: boolean): StepComponent[] => {
	let steps: StepComponent[] = [
		{
			step: SELECT_THIRD_PARTY_ENTITY_STEP,
			overrides: {
				overrideReturnStep: SELECT_SOURCE_STEP,
			},
			stepProps: {
				thirdParty: TRELLO,
				stats: hiddenUsers
					? [StatisticsType.TASKS]
					: [StatisticsType.TASKS, StatisticsType.MEMBERS],
				shouldShowPlaceholderIcons: true,
			},
			progressBarStepLabel: messages.trelloStepLabel,
		},
		{
			...DEFAULT_CONFIG,
			step: USER_MAPPING_STEP,
			stepProps: {
				hasProgressBar: true,
				thirdParty: TRELLO,
			},
			progressBarStepLabel: messages.userMappingStepLabel,
		},
		{
			...DEFAULT_CONFIG,
			step: PROJECT_CREATE_STEP,
			stepProps: {
				hasProgressBar: true,
				shouldPrefillThirdPartyProjectName: true,
				shouldShowThirdPartyStats: !hiddenUsers,
				thirdParty: TRELLO,
				shouldStartImportOnNext: true,
				isTMPSupported: true,
				templates: [],
			},
			progressBarStepLabel: commonMessages.projectCreateStepLabel,
		},
		{
			step: IMPORT_IN_PROGRESS_STEP,
			overrides: {
				overrideReturnStep: SELECT_SOURCE_STEP,
			},
			stepProps: {
				hasProgressBar: true,
				thirdParty: TRELLO,
			},
			progressBarStepLabel: commonMessages.importInProgressStepLabel,
		},
	];
	if (hiddenUsers) steps = steps.filter((step) => step.step !== USER_MAPPING_STEP);
	return steps;
};
